import React from "react";

const Loading = () => {
  return (
    <div className="d-flex justify-content-center p-3">
      <p>Loading...</p>
    </div>
  );
};

export default Loading;
